export function hasAnsweredCounter(persons){
    let counter = 0;
    persons.map((person) => {
        if(person.hasAnswered){
            counter++;
        }
    })
    return counter;
}